import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  Optional,
  TemplateRef,
  ViewEncapsulation,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { BixiLayoutService } from '../layout.service';
import { IBreadcrumb } from '../layout.type';
import { Subscription } from 'rxjs';

@Component({
  selector: 'bixi-layout-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'bixiLayoutHeader',
  host: {
    class: 'bixi-layout-header',
    '[class.bixi-layout-header-collapsed]': '!open',
    '[class.bixi-layout-header-opened]': 'open'
  }
})
export class BixiHeaderComponent implements OnDestroy {
  @Input() logoSmall: string;
  @Input() logoLarge: string;
  @Input() logoBackgroundSmall: string;
  @Input() logoBackgroundLarge: string;
  @Input() logoType: 'image' | 'text' = 'image';
  @Input() breadcrumbs: string | TemplateRef<void>;
  @Input() tools: string | TemplateRef<void>;

  @Output() logoClick: EventEmitter<Event> = new EventEmitter<Event>();
  subscription = new Subscription();
  open = true;
  breads: IBreadcrumb[];
  logo = '';
  constructor(
    @Optional() public cdr: ChangeDetectorRef,
    private layoutService: BixiLayoutService
  ) {
    this.subscription.add(
      this.layoutService.openChange.subscribe((open: boolean) => {
        this.open = open;
        if (this.cdr) {
          this.cdr.markForCheck();
        }
      })
    );
    this.subscription.add(
      this.layoutService.breadcrumb$.subscribe((breads: IBreadcrumb[]) => {
        this.breads = breads;
        if (this.cdr) {
          this.cdr.markForCheck();
        }
      })
    );
  }

  get logoStyle() {
    if (this.open && this.logoBackgroundLarge) {
      return {
        'background-image': `url(${this.logoBackgroundLarge})`
      };
    }
    if (!this.open && this.logoBackgroundSmall) {
      return {
        'background-image': `url(${this.logoBackgroundSmall})`
      };
    }
    return {};
  }

  get logoImageOrText() {
    return this.open ? this.logoLarge : this.logoSmall;
  }

  get logoClass() {
    return this.open ? 'bixi-layout-header-logo-full' : 'bixi-layout-header-logo-small';
  }

  onLogoClick(e: Event) {
    // 默认点击跳转到首页。用户配置路由跳转可覆盖当前跳转
    this.logoClick.emit(e);
  }

  onOpenChange() {
    this.layoutService.toggleMenu();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
